import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import FormDialog, {FormDialogProps} from 'cl-dialogs/FormDialog';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';

export interface DisconnectChannelAccountDialogProps extends FormDialogProps {
  sellerId: string;
  channel: string;
  text: React.ReactNode;
}

export default class DisconnectChannelAccountDialog extends React.PureComponent<DisconnectChannelAccountDialogProps> {
  render() {
    const {sellerId, channel, text, ...props} = this.props;
    return (
      <FormDialog
        formName={GENERAL_ACTIONS_TYPES.DISCONNECT_CHANNEL_ACCOUNT}
        title={`Disconnect ${channel} account`}
        text={text}
        actions={
          <GeneralActions
            types={[GENERAL_ACTIONS_TYPES.DISCONNECT_CHANNEL_ACCOUNT]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            additionalActionData={{sellerId, channel}}
            lastActionColor="error"
          />
        }
        {...props}
      />
    );
  }
}
